export const PRIMARY_COLOR = '#14b7ae'
export const SECONDARY_COLOR = '#05a8ff'
export const WARNING_COLOR = '#FF4800'
export const GREY_COLOR = '#E9E8E8'
export const MAD_BLACK = '#686464'
export const BLUE_COLOR = '#3B539D'
